import { Navigate } from 'react-router'

import { withNamespaces } from '@/i18n/route-namespaces'

export const knowledgeBaseRoutes = {
  path: 'knowledge-base',
  lazy: withNamespaces(['knowledgeBase'], async () => {
    const { KnowledgeBase } = await import('@/pages/knowledge-base')

    return { Component: KnowledgeBase }
  }),
  children: [
    {
      index: true,
      element: <Navigate to="content-groups" />,
    },
    {
      path: 'content-groups',
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['knowledgeBase'], async () => {
            const { KnowledgeBaseContentGroupsList } = await import(
              '@/pages/knowledge-base/groups/list'
            )

            return { Component: KnowledgeBaseContentGroupsList }
          }),
        },
      ],
    },
  ],
}
